jQuery(document).ready(function($) {


    ////////////////////////////////
    //  Email - Parse JavaScript  //
    ////////////////////////////////

    $("a.safe").each( function () {
        // Build mail adrees from data-pre and data-post attributes, add as href and node content, and remove target attribute
        $(this).attr('href', 'mailto:' + $(this).data('pre') + '@' + $(this).data('post')).html($(this).data('pre') + '@' + $(this).data('post')).removeAttr('target');
    });

    /*
    ////////////////////////
    //  Scroll to anchor  //
    ////////////////////////

    // Smooth scroll for hash anchors (scroll down to contact form)
    $('a[href*=\\#]:not([href=\\#])').on('click', function (event) {
        
        event.preventDefault();
        
        // Trigger close button click
        if ($("#offCanvasLeft").hasClass("is-open")) {
            $("#offCanvasLeftCloseBtn").click();
        }
        
        // Animate to hash element
        var element = $(this.hash);
        $('html,body').animate({ scrollTop: element.offset().top }, 600);
        return false;
    });
    */
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//  Bookmark button script                                                                                         //
//  From https://www.thewebflash.com/how-to-add-a-cross-browser-add-to-favorites-bookmark-button-to-your-website/  //
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*
jQuery(function($) {
    
    $('.bookmark-button').click(function(e) {
        if (window.sidebar) { // Mozilla Firefox Bookmark
            window.sidebar.addPanel(location.href,document.title,"");
          } else if(window.external) { // IE Favorite
            window.external.AddFavorite(location.href,document.title); }
          else if(window.opera && window.print) { // Opera Hotlist
            this.title=document.title;
            return true;
          }
    });
    
  });
*/